import React from "react";
import Header from '../component/Header';
import Footer from '../component/Footer';
import { Outlet } from 'react-router-dom';

export default function UserLayout({headerClass, footerHide, removeHeader}) {
  return (
    <>
    {!removeHeader &&
      <Header headerClass={headerClass}/>}
      <main>
          <Outlet />
      </main>
      <Footer footerHide={footerHide}/>
    </>
  )
}
